import {
    Grid,
    Box,
} from '@material-ui/core';
import { useTranslation } from 'components/providers/TranslationProvider';
import {
  TextField as TextFieldCustom,
} from 'components/common/ReactHooksFormFields';

import {
  MuiGrid,
} from './styles/recommendations';
import { 
  Typography,
  InputAdornment, 
} from '@mui/material';

const RecommendationsVisualization = ( props ) => {
    const { t } = useTranslation();

    return (
      <MuiGrid item xs={12} sx={{ paddingLeft: '8px !important', paddingRight: '8px !important'  }}>
        <Box sx={{marginBottom: '8px'}}>
          <Typography sx={{marginTopBottom: '16px'}}>
            {t('glossary_demand')}
          </Typography>
        </Box>
        <Grid container alignItems='center' sx={{ gap: '24px'}}>
          <Grid item xs={6}>
            <Box sx={{ width: '478px', marginBottom: '24px'}} >
              <TextFieldCustom
                  name='recommendationsDemandDensityLabel'
                  type='text'
                  margin='dense'
                  label={t('recommendations_demand_density')}
                  fullWidth
                  variant='outlined'
                  color='primary'
                />
            </Box>
          </Grid>
          <Grid item xs={6}>
          <Box sx={{ width: '478px', marginBottom: '24px'}} >
            <TextFieldCustom
                name='recommendationsFormulaPriorizationVariableLabel'
                type='text'
                margin='dense'
                label={t('recommendations_formula_priorization_variable')}
                fullWidth
                variant='outlined'
                color='primary'
              />
          </Box>
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ width: '478px' }} >
              <TextFieldCustom
                name='variableWelfareLabel'
                type='text'
                margin='dense'
                label={t('variable_welfare')}
                fullWidth
                variant='outlined'
                color='primary'
              />
            </Box>
          </Grid>            
        </Grid>
        <Box sx={{ marginBottom: '16px', marginTop: '20px' }}>
          <Typography sx={{marginTopBottom: '16px'}}>
            {t('glossary_service_point')}
          </Typography>
        </Box>
        <Grid container alignItems='center'>
          <Grid item xs={6}>
            <Box sx={{ width: '478px', marginBottom: '20px'}} >
              <TextFieldCustom
                name='coverageRadiusLabel'
                type='text'
                margin='dense'
                label={t('coverage_radius')}
                fullWidth
                variant='outlined'
                color='primary'
              />
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ width: '478px', marginBottom: '20px'}} >
            <TextFieldCustom
              name='costLabel'
              type='text'
              margin='dense'
              label={t('cost')}
              fullWidth
              variant='outlined'
              color='primary'
            />
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ width: '478px', marginBottom: '20px'}} >
            <TextFieldCustom
              name='recommendationsOfferCapacityLabel'
              type='text'
              margin='dense'
              label={t('recommendations_offer_capacity')}
              fullWidth
              variant='outlined'
              color='primary'
            />
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ width: '478px', marginBottom: '20px'}} >
            <TextFieldCustom
              name='recommendationsBudgetLabel'
              type='text'
              margin='dense'
              label={t('recommendations_budget')}
              fullWidth
              variant='outlined'
              color='primary'
            />
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ width: '478px'}} >
            <TextFieldCustom
              name='recommendationsExpansionCapacityLabel'
              type='text'
              margin='dense'
              label={t('recommendations_expansion_capacity')}
              fullWidth
              variant='outlined'
              color='primary'
            />
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ width: '478px'}} >
            <TextFieldCustom
              name='recommendationsExpansionCostLabel'
              type='text'
              margin='dense'
              label={t('recommendations_expansion_cost')}
              fullWidth
              variant='outlined'
              color='primary'
            />
            </Box>
          </Grid>
        </Grid>
        <Box>
          <Typography sx={{marginTop: '20px', marginBottom: '18px'}}>
            { t('statistic_histogram_widget') }
          </Typography>
        </Box>
        <Grid container alignItems='center'>
          <Grid item xs={6}>
            <Box display="flex">
              <Box sx={{ width: '302px' }}>
                <TextFieldCustom
                  name='variableWelfareStatisticLabel'
                  type='text'
                  margin='dense'
                  label={t('variable_welfare')}
                  fullWidth
                  variant='outlined'
                  color='primary'
                />
              </Box>
              <Box sx={{ width: '72px', marginLeft: '16px', marginRight: '16px' }}>
                <TextFieldCustom
                  name='variableWelfarePrefixStatisticLabel'
                  type='text'
                  margin='dense'
                  label={t('prefix')}
                  fullWidth
                  variant='outlined'
                  color='primary'
                  InputProps={{
                    startAdornment: <InputAdornment position="start">%</InputAdornment>,
                  }}
                />
              </Box>
              <Box sx={{ width: '72px' }}>
                <TextFieldCustom
                  name='variableWelfareSuffixStatisticLabel'
                  type='text'
                  margin='dense'
                  label={t('suffix')}
                  fullWidth
                  variant='outlined'
                  color='primary'
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                  }}
                />
              </Box>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box display="flex">
              <Box sx={{ width: '302px' }}>
                <TextFieldCustom
                  name='densityVariableStatisticLabel'
                  type='text'
                  margin='dense'
                  label={t('density_variable')}
                  fullWidth
                  variant='outlined'
                  color='primary'
                />
              </Box>
              <Box sx={{ width: '72px', marginLeft: '16px', marginRight: '16px' }}>
                <TextFieldCustom
                  name='densityVariablePrefixStatisticLabel'
                  type='text'
                  margin='dense'
                  label={t('prefix')}
                  fullWidth
                  variant='outlined'
                  color='primary'
                  InputProps={{
                    startAdornment: <InputAdornment position="start">%</InputAdornment>,
                  }}
                />
              </Box>
              <Box sx={{ width: '72px' }}>
                <TextFieldCustom
                  name='densityVariableSuffixStatisticLabel'
                  type='text'
                  margin='dense'
                  label={t('suffix')}
                  fullWidth
                  variant='outlined'
                  color='primary'
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                  }}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </MuiGrid>
    );
};

export default RecommendationsVisualization;